import Records from './records.vue'

export default Records
